import type { EpisodeInvalidReason, EpisodeValidationStatus } from "@/api/episodeReviewState";

/**
 * 에피소드 **검증** 축과 결함 사유의 한글 표시 문구(제품 카피, FE 소유).
 *
 * 검증은 진단·반입이 자동으로 매기는 판정이다. 사람이 쓰는 결과(`task_failed`)와 다르다. 두 값 모두
 * 서버 enum 이라 exhaustive `Record` 로 둔다. 서버가 값을 늘리면 `tsc` 가 오류를 낸다.
 */
export const EPISODE_VALIDATION_TEXT: Record<EpisodeValidationStatus, string> = {
  pending: "미검증",
  valid: "유효",
  invalid: "무효",
};

export const EPISODE_INVALID_REASON_TEXT: Record<EpisodeInvalidReason, string> = {
  corrupt_parquet: "Parquet 파일 손상",
  missing_video: "영상 누락",
  unreadable_video: "영상 읽기 실패",
  timeline_invalid: "타임라인 불일치",
  missing_channel: "채널 누락",
  unverified: "검증 미완료",
};
